export default "__VITE_ASSET__4qPInic1__"